import { useMutation, useQueryClient } from "@tanstack/react-query";
import { laddersApi } from "../../api/ladders";
import { ladderKeys } from "../queries/useLadder";

export const useCreateLadder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: laddersApi.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ladderKeys.all });
    },
  });
};

export const useUpdateLadder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: laddersApi.update,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ladderKeys.all });
    },
  });
};

export const useAddOrganizer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: laddersApi.addOrganizer,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ladderKeys.detail(data.id) });
    },
  });
};

export const useRemoveOrganizer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: laddersApi.removeOrganizer,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ladderKeys.detail(data.id) });
    },
  });
};

export const useTransferLadderOwnership = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: laddersApi.transferOwnership,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ladderKeys.all });
    },
  });
};
